// extracted by mini-css-extract-plugin
export var bodySections = "_dg-8";
export var gray = "_dg-7";
export var green = "_dg-4";
export var iconContainer = "_dg-9";
export var iconWidgetContainer = "_dg-1";
export var phoneIcon = "_dg-2";
export var red = "_dg-5";
export var statusDot = "_dg-3";
export var widgetContainer = "_dg-0";
export var yellow = "_dg-6";